/**
 * 見積の支払い方法未設定時、マスタの「現金・振込」を既定にする。
 */
export function applyDefaultEstimatePaymentMethod(estimate: {
  paymentMethod?: string;
  estimatePaymentMethods?: string[];
}): void {
  const pm = estimate.paymentMethod;
  if (pm != null && String(pm).trim() !== "") {
    return;
  }
  const methods = estimate.estimatePaymentMethods || [];
  const defaultName = "現金・振込";
  estimate.paymentMethod = methods.includes(defaultName)
    ? defaultName
    : methods.length > 0
    ? methods[0]
    : "";
}
